module.exports = __webpack_public_path__ + "src/img/msg.4da279fd.svg";